/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M6.5 9.5L7.31992 10.0857C8.30145 10.7868 8.79222 11.1373 9.14672 11.589C9.46064 11.9891 9.69542 12.4453 9.83846 12.9332C10 13.4842 10 14.0873 10 15.2936V20C10 21.1046 10.8954 22 12 22V22C13.1046 22 14 21.1046 14 20V17"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M6.5 9.5L5.73837 8.95598C4.01989 7.72849 3 5.74665 3 3.6348V3.6348C3 2.73193 3.73193 2 4.6348 2H19.3652C20.2681 2 21 2.73193 21 3.6348V3.6348C21 5.74665 19.9801 7.72849 18.2616 8.95598L16.3333 10.3333C15.6912 10.792 15.3702 11.0213 15.1111 11.2919C14.5752 11.8514 14.2134 12.5545 14.0696 13.3157C14 13.6838 14 14.0784 14 14.8674V17"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M19.3652 2H4.6348C3.73193 2 3 2.73193 3 3.6348C3 5.74665 4.01989 7.72849 5.73837 8.95598L7.66667 10.3333L7.66668 10.3333C8.30877 10.792 8.62982 11.0213 8.88894 11.2919C9.42476 11.8514 9.78657 12.5545 9.93043 13.3157C10 13.6838 10 14.0784 10 14.8674V20C10 21.1046 10.8954 22 12 22C13.1046 22 14 21.1046 14 20V14.8674C14 14.0784 14 13.6838 14.0696 13.3157C14.2134 12.5545 14.5752 11.8514 15.1111 11.2919C15.3702 11.0213 15.6912 10.792 16.3333 10.3333L18.2616 8.95598C19.9801 7.72849 21 5.74665 21 3.6348C21 2.73193 20.2681 2 19.3652 2Z"
				fill="currentColor"
			/>
			<path
				d="M19.3652 2H4.6348C3.73193 2 3 2.73193 3 3.6348C3 5.74665 4.01989 7.72849 5.73837 8.95598L7.66667 10.3333L7.66668 10.3333C8.30877 10.792 8.62982 11.0213 8.88894 11.2919C9.42476 11.8514 9.78657 12.5545 9.93043 13.3157C10 13.6838 10 14.0784 10 14.8674V20C10 21.1046 10.8954 22 12 22C13.1046 22 14 21.1046 14 20V14.8674C14 14.0784 14 13.6838 14.0696 13.3157C14.2134 12.5545 14.5752 11.8514 15.1111 11.2919C15.3702 11.0213 15.6912 10.792 16.3333 10.3333L18.2616 8.95598C19.9801 7.72849 21 5.74665 21 3.6348C21 2.73193 20.2681 2 19.3652 2Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M4.25622 1.25C4.25044 1.25 4.24756 1.25 4.24512 1.25001C3.14436 1.25269 2.25269 2.14436 2.25001 3.24512C2.25 3.24756 2.25 3.25045 2.25 3.25622C2.25 3.26869 2.25 3.27493 2.25001 3.28084C2.25381 5.85611 3.49711 8.27207 5.59048 9.77201C5.59528 9.77545 5.60036 9.77908 5.61051 9.78633L8.74028 12.0219C9.06016 12.2504 9.25 12.6193 9.25 13.0124V20C9.25 21.5188 10.4812 22.75 12 22.75C13.5188 22.75 14.75 21.5188 14.75 20V13.0124C14.75 12.6193 14.9398 12.2504 15.2597 12.0219L18.3895 9.78633C18.3996 9.77908 18.4047 9.77545 18.4095 9.77201C20.5029 8.27207 21.7462 5.85611 21.75 3.28084C21.75 3.27493 21.75 3.26869 21.75 3.25622C21.75 3.25045 21.75 3.24756 21.75 3.24512C21.7473 2.14436 20.8556 1.25269 19.7549 1.25001C19.7524 1.25 19.7496 1.25 19.7438 1.25H4.25622Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M15 2H19.3652C20.2681 2 21 2.73193 21 3.6348V3.6348C21 5.74665 19.9801 7.72849 18.2616 8.95598L16.3333 10.3333C15.6912 10.792 15.3702 11.0213 15.1111 11.2919C14.5752 11.8514 14.2134 12.5545 14.0696 13.3157C14 13.6838 14 14.0784 14 14.8674V20C14 21.1046 13.1046 22 12 22V22C10.8954 22 10 21.1046 10 20V14.8674C10 14.0784 10 13.6838 9.93043 13.3157C9.78657 12.5545 9.42476 11.8514 8.88894 11.2919C8.62982 11.0213 8.30877 10.792 7.66667 10.3333L5.73837 8.95598C4.01989 7.72849 3 5.74665 3 3.6348V3.6348C3 2.73193 3.73193 2 4.6348 2H10"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M19.3652 2H4.6348C3.73193 2 3 2.73193 3 3.6348C3 5.74665 4.01989 7.72849 5.73837 8.95598L7.66667 10.3333L7.66668 10.3333C8.30877 10.792 8.62982 11.0213 8.88894 11.2919C9.42476 11.8514 9.78657 12.5545 9.93043 13.3157C10 13.6838 10 14.0784 10 14.8674V20C10 21.1046 10.8954 22 12 22C13.1046 22 14 21.1046 14 20V14.8674C14 14.0784 14 13.6838 14.0696 13.3157C14.2134 12.5545 14.5752 11.8514 15.1111 11.2919C15.3702 11.0213 15.6912 10.792 16.3333 10.3333L18.2616 8.95598C19.9801 7.72849 21 5.74665 21 3.6348C21 2.73193 20.2681 2 19.3652 2Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M4.00622 1C4.00044 1 3.99756 1 3.99512 1.00001C2.89436 1.00269 2.00269 1.89436 2.00001 2.99512C2 2.99756 2 3.00045 2 3.00622C2 3.01869 2 3.02493 2.00001 3.03084C2.00381 5.60611 3.24711 8.02207 5.34048 9.52201C5.34528 9.52545 5.35036 9.52908 5.36051 9.53633L8.49028 11.7719C8.81016 12.0004 9 12.3693 9 12.7624V19.75C9 21.2688 10.2312 22.5 11.75 22.5C13.2688 22.5 14.5 21.2688 14.5 19.75V12.7624C14.5 12.3693 14.6898 12.0004 15.0097 11.7719L18.1395 9.53633C18.1496 9.52908 18.1547 9.52545 18.1595 9.52201C20.2529 8.02207 21.4962 5.60611 21.5 3.03084C21.5 3.02493 21.5 3.01869 21.5 3.00622C21.5 3.00045 21.5 2.99756 21.5 2.99512C21.4973 1.89436 20.6056 1.00269 19.5049 1.00001C19.5024 1 19.4996 1 19.4938 1H4.00622Z"
				fill="currentColor"
			/>
			<path
				d="M9 16.75V19.75C9 21.2688 10.2312 22.5 11.75 22.5C13.2688 22.5 14.5 21.2688 14.5 19.75V16.75C14.5 15.2312 13.2688 14 11.75 14C10.2312 14 9 15.2312 9 16.75Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
